module.exports = __webpack_public_path__ + "static/media/mywebsiteprofile2.f79a459c.jpg";